import { Box, styled } from '@mui/material';

export const TrlAccountInfoContainerStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.colors.infoBackground,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
